module.exports = __webpack_public_path__ + "static/media/Mesa-Bar.a2a13bd2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Img/productos/Mesa-Bar.jpg
// module id = 148
// module chunks = 0